/** Brand marks for the sequencers Sendepot integrates with. Logos are
 * served from /sequencers/<name>.png in webapp/web/public/ so designers
 * can drop in updated artwork without touching the React tree. */

function LogoImg({
  src, alt, className = 'w-9 h-9',
}: { src: string; alt: string; className?: string }) {
  return (
    <img
      src={src} alt={alt}
      className={`${className} rounded-lg object-contain`}
      loading="lazy"
    />
  );
}

export function InstantlyMark({ className = 'w-7 h-7' }: { className?: string }) {
  return <LogoImg src="/sequencers/instantly.ai.png" alt="Instantly.ai" className={className} />;
}

export function SmartleadMark({ className = 'w-7 h-7' }: { className?: string }) {
  // Smartlead's PNG has slight internal padding versus Instantly's
  // edge-to-edge mark. object-cover trims the transparent border so
  // the two read at the same visual size — no scale transform.
  return (
    <img
      src="/sequencers/smartlead.png"
      alt="Smartlead"
      className={`${className} rounded-lg object-cover`}
      loading="lazy"
    />
  );
}

/** Marquee-style "connects with" strip with the live integrations. */
export default function SequencerLogos() {
  return (
    <div className="card p-6 md:p-8">
      <div className="text-center mb-6">
        <div className="text-[11px] uppercase tracking-[0.18em] text-accent mb-2">Connects with</div>
        <p className="text-sm text-dim">
          Mailboxes connect automatically — no manual setup, no copy-pasting credentials.
        </p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-10 md:gap-14">
        <Pill mark={<InstantlyMark className="w-9 h-9" />} name="Instantly" />
        <Pill mark={<SmartleadMark className="w-9 h-9" />} name="Smartlead" />
      </div>
      <p className="text-center text-[11px] text-dim mt-6">
        More sequencers coming soon.
      </p>
    </div>
  );
}

function Pill({ mark, name }: { mark: React.ReactNode; name: string }) {
  return (
    <div className="flex items-center gap-3">
      <div className="shrink-0">{mark}</div>
      <div>
        <div className="text-sm font-medium text-ink">{name}</div>
        <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-emerald-400">Live</span>
        </div>
      </div>
    </div>
  );
}
